import { render, staticRenderFns } from "./PendingEditRequestMentoringLanguagesValues.vue?vue&type=template&id=573c9524&"
import script from "./PendingEditRequestMentoringLanguagesValues.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestMentoringLanguagesValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports